import React ,{useState} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { ThemeProvider } from '@mui/material/styles';
import { SoundProvider } from './components/SoundContext';
import {getTheme} from './styles/themeProvider';

const Root = () => {
  const [fontFamily, setFontFamily] = useState('MyHandwritten');
  const theme = getTheme(fontFamily);

  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <SoundProvider>
          <App onFontChange={setFontFamily} />
        </SoundProvider>
        
      </ThemeProvider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
